import { FC } from 'react';

import { getSeasonConfig } from './get-season-config';
import { useSeasonalTheme } from './seasonal-theme-context';

/**
 * Seasonal Effects Component
 * Renders non-intrusive seasonal animations and effects when the theme is enabled
 * Automatically uses the effects from the active season configuration
 */
export const SeasonalEffects: FC = () => {
	const { isSeasonalThemeEnabled } = useSeasonalTheme();
	const seasonConfig = getSeasonConfig();

	if (!isSeasonalThemeEnabled) {
		return null;
	}

	const { EffectsComponent } = seasonConfig;

	return <EffectsComponent />;
};
